import { httpGet_New } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { LUCTransferResponse } from '../types/luc-transfer';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { LUCTransferReceipt } from '../types/luc-transfer-receipt';

export const getLucTransfers = async (request?: PaginatedRequest): Promise<PaginatedResult<LUCTransferResponse>> => {
  return await httpGet_New<PaginatedResult<LUCTransferResponse>>(`api/luctransfer`, request);
};

export const getLucTransfersReceipts = async (request?: PaginatedRequest): Promise<PaginatedResult<LUCTransferReceipt>> => {
  return await httpGet_New<PaginatedResult<LUCTransferReceipt>>(`api/luctransfer-receipt`, request);
};

export const getLucTransfersReceiptById = async (id: string): Promise<LUCTransferReceipt> => {
  return await httpGet_New<LUCTransferReceipt>(`api/luctransfer-receipt/${id}`);
};
